import { api } from './api'

export interface Cardapio {
  id_cardapio: number
  nome_cardapio: string
  descricao_cardapio: string
  data_cadastro: string
  validade: string
  id_file: number
  createdAt: string
  updatedAt: string
}

export interface CreateCardapioData {
  nome_cardapio: string
  descricao_cardapio: string
  validade: string
  file: File
}

export interface UpdateCardapioData {
  id_cardapio: number
  nome_cardapio: string
  descricao_cardapio: string
  validade: string
}

export const cardapioService = {
  async getAll() {
    try {
      const response = await api.get('/get-cardapios')
      return {
        success: true,
        data: response.data.cardapios || []
      }
    } catch (error: any) {
      console.error('Erro ao buscar cardápios:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao carregar cardápios'
      }
    }
  },

  async getById(id: number) {
    try {
      const response = await api.get(`/get-cardapio/${id}`)
      return {
        success: true,
        data: response.data.cardapio
      }
    } catch (error: any) {
      console.error('Erro ao buscar cardápio:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao carregar cardápio'
      }
    }
  },

  async create(data: CreateCardapioData) {
    try {
      const formData = new FormData()
      formData.append('nome_cardapio', data.nome_cardapio)
      formData.append('descricao_cardapio', data.descricao_cardapio)
      formData.append('validade', data.validade)
      formData.append('file', data.file)

      const response = await api.post('/create-cardapio', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      return {
        success: true,
        data: response.data.cardapio
      }
    } catch (error: any) {
      console.error('Erro ao criar cardápio:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao criar cardápio'
      }
    }
  },

  async update(data: UpdateCardapioData) {
    try {
      const response = await api.put('/update-cardapio', data)
      return {
        success: true,
        data: response.data.cardapio
      }
    } catch (error: any) {
      console.error('Erro ao atualizar cardápio:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao atualizar cardápio'
      }
    }
  },

  async delete(id: number) {
    try {
      await api.delete(`/delete-cardapio/${id}`)
      return {
        success: true
      }
    } catch (error: any) {
      console.error('Erro ao deletar cardápio:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao deletar cardápio'
      }
    }
  }
}
